
import { mapGetters } from "vuex";
import Pencil from "vue-material-design-icons/Pencil.vue";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import TableApp from "@/components/Table/Table2";
import FilterFields from "@/components/FilterFields";

export default {
  name: "app-lista-preco-servico",
  components: {
    Pencil,
    TrashCanIcon,
    TableApp,
    FilterFields,
  },
  data() {
    return {
      fields: [
        {
          label: "Descrição",
          field: "descricao",
          type: "text",
          slot: true,
          sortable: true,
          filterOptions: { enabled: false },
        },
        {
          label: "Status",
          field: "status",
          width: "10%",
          sortable: false,
          slot: true,
          filterOptions: { enabled: false },
        },
        {
          label: "Ações",
          field: "actions",
          width: "15%",
          sortable: false,
          slot: true,
          filterOptions: { enabled: false },
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
  methods: {
    excluir(lista) {
      this.$swal
        .fire({
          icon: "warning",
          title: `Excluir a lista ${lista.descricao}?`,
          showCancelButton: true,
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (!result.isConfirmed) return;

          await this.$http.post("/servicos/lista-preco/delete", {
            id_lista_preco_servico: lista.id_lista_preco_servico,
          });
          this.$refs.listaPrecos.refresh();
          this.$toast.success("Lista de preços de serviços excluída!");
        });
    },
  },
};
